// extracted by mini-css-extract-plugin
module.exports = {"retellingSticker":"RetellingSticker_retellingSticker__Qee8x"};